import getUrl from 'airship/modules/get-url'
import {Response} from 'airship/modules/request2/index'
import createRequest from 'airship/modules/request2/ua-request'

import {CustomerFeedbackForm} from './type'

const FORM_SUBMISSION = 'product-research:submission'

export const postForm = async (
  formData: CustomerFeedbackForm
): Promise<Response<void>> => {
  const path = getUrl(FORM_SUBMISSION)
  const req = createRequest({path})
  const body = formData
  const res = await req.post({body})
  return res
}
